export default {
  text_placeholder: 'Введіть повідомлення...',
  attach: {
    attach_image: {
      btn_select: 'Прикріпити зображення',
      title: 'Виберіть зображення',
      dropzone: {
        description: '<p> Ви можете завантажити зображення, що відповідає вимогам:</p><p> Максимальний розмір зображення 1600×1200px, до 2Мб.</p><p> Або вибрати із галереї раніше завантажених зображень.</p>',
      },
    },
    attach_video: {
      btn_select: 'Прикріпити відео',
      title: 'Виберіть відео',
      dropzone: {
        description: '<p> Ви можете завантажити відео, яке відповідає вимогам:</p><p> Розмір відео до 200 Мб, формат 3gp, m4v, mov, mp4.</p><p> Або вибрати із раніше завантажених відео.</p>',
      },
    },
    attach_document: {
      btn_select: 'Прикріпити документ',
      title: 'Виберіть документ',
      dropzone: {
        description: '<p> Ви можете завантажити відео, яке відповідає вимогам:</p><p> Розмір відео до 200 Мб, формат 3gp, m4v, mov, mp4.</p><p> Або вибрати із раніше завантажених відео.</p>',
      },
      upload_description: {
        viber: 'Ви можете завантажити файл, який відповідає вимогам:<br>' +
          'Максимальний розмір файлу 200Мб<br>' +
          'Розширення файлу: .doc, .docx, .rtf, .dot, .dotx, .odt ,odf, .fodt, .txt, .info, .pdf, .xps, .pdax, .eps, .xls, .xlsx, .ods, .fods, .csv, .xlsm, .xltx',
        whatsapp: 'Ви можете завантажити файл, який відповідає вимогам:<br>' +
          'Максимальний розмір файлу 100Мб',
      },
    },
    modal: {
      title: 'Долдати файл',
      description: 'Вибрати файл або завантажити щоб додати до повідомлення',
      btn_upload: 'Завантажити',
      empty_description: 'В галереї акаунту відсутні зображення.<br>Завантажте зображення, що відповідає вимогам.',
      empty_video_description: 'В галереї акаунту відсутні відео.<br>Завантажте відео, що відповідає вимогам.',
      empty_document_description: 'В галереї акаунту відсутні документи.<br>Завантажте документ, що відповідає вимогам.',
    },
  },
  fast_answers: {
    more: 'Більше',
  },
  reassign: {
    start_chatting: 'Почати діалог',
    assign_to_user: 'Призначити на користувача ...',
  },
};
